import axios from 'common/AxiosAuth';

export interface ScheduleBufferResponse {
  id: number;
  bufferMinutes: number;
  updatedAt?: string | null;
}

export interface ScheduleBufferRequest {
  bufferMinutes: number;
}

export const getScheduleBuffer = async () => {
  const { data } = await axios.get<ScheduleBufferResponse>('/api/schedule/schedule-buffer');
  return data;
};

export const createScheduleBuffer = async (payload: ScheduleBufferRequest) => {
  const { data } = await axios.post<ScheduleBufferResponse>('/api/admin/schedule-buffer', payload);
  return data;
};

export const updateScheduleBuffer = async (payload: ScheduleBufferRequest) => {
  const { data } = await axios.put<ScheduleBufferResponse>('/api/admin/schedule-buffer', payload);
  return data;
};

export const deleteScheduleBuffer = async (id: number): Promise<boolean> => {
  const normalize = (status: number, data: any): boolean => {
    if (status >= 200 && status < 300) return true;
    if (data === 1 || data === '1' || data === true) return true;
    return false;
  };

  try {
    const res = await axios.delete(`/api/admin/schedule-buffer/${id}`);
    return normalize(res.status, res.data);
  } catch (err: any) {
    const status = err?.response?.status;
    if (status === 400 || status === 404 || status === 405) {
      // 1차 폴백: query param 방식
      try {
        const res = await axios.delete(`/api/admin/schedule-buffer`, { params: { id } });
        return normalize(res.status, res.data);
      } catch (_) {
        // 2차 폴백: DELETE body 허용 방식
        const res = await axios.delete(`/api/admin/schedule-buffer`, { data: { id } });
        return normalize(res.status, res.data);
      }
    }
    throw err;
  }
};


